module.exports = "<a routerLink=\"/folder/{{ id }}\" [ngClass]=\"{mobile: mobile}\">\n  <div class=\"title\">\n    <i class=\"material-icons\" data-icon=\"folder_open\">&#xe2c8;</i>\n    <h3>{{ name }}</h3>\n    <div *ngIf=\"messages\" [ngClass]=\"{notification: true, badge: true}\">\n      {{ messages }}\n    </div>\n  </div>\n</a>\n"


//////////////////
// WEBPACK FOOTER
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/folder/folder-view/folder-view-grid/folder-view-grid-folderitem/folder-view-grid-folderitem.component.html
// module id = ../../../../../src/app/folder/folder-view/folder-view-grid/folder-view-grid-folderitem/folder-view-grid-folderitem.component.html
// module chunks = main